import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";

function BusTipsContent() {
    const title = useTranslation(`${singleModalTranslationKey}.buses.title`)
    const {
        title: subtitle,
        o1,
        o2,
        o3,
        o4,
        o5,
    } = useTranslation(`${singleModalTranslationKey}.buses.tips`)

    return (
        <TipsPerTransportType
            title={title}
            subtitle={subtitle}
            options={[
                {id: "bus-o1", option: o1},
                {id: "bus-o2", option: o2},
                {id: "bus-o3", option: o3},
                {id: "bus-o4", option: o4},
                {id: "bus-o5", option: o5},
            ]}
        />
    );
}

export default BusTipsContent